<template>
  <div>
    <div>
      <h2 class="th-title">Daftar Users</h2>
    </div>
    <a-card>
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <a-input-search
            placeholder="Cari Nama User..."
            v-model:value="search"
            style="width: 250px"
            class="mr-3"
          />
          <a-select v-model:value="selectedRole" placeholder="Filter by Role" style="width: 200px">
            <a-select-option v-for="role in roles" :key="role.value" :value="role.value">
              {{ role.label }}
            </a-select-option>
          </a-select>
        </div>

        <router-link :to="{ path: `/users/create` }">
          <a-button> <PlusOutlined />New Users </a-button>
        </router-link>
      </div>
      <div class="mt-3">
        <a-table :columns="columns" :data-source="filteredData" :loading="loading" bordered>
          <template #name="{ text, record }">
            <router-link :to="{ path: `/users/${record.id}` }" class="vb__utils__link">
              {{ text }}
            </router-link>
          </template>
          <template #action="{ record }">
            <a-button
              type="danger"
              @click="openDeleteModal(record.id)"
              :disabled="record.id == userData.id"
            >
              <RestOutlined :style="{ color: 'white' }" />
            </a-button>
          </template>
        </a-table>
      </div>
    </a-card>

    <a-modal
      v-model:visible="isDeleteModalVisible"
      title="Konfirmasi Penghapusan"
      ok-text="Hapus"
      ok-type="danger"
      cancel-text="Batal"
      centered
      @ok="handleDelete"
      @cancel="closeDeleteModal"
    >
      <p>Apakah Anda yakin ingin menghapus user ini? Data yang dihapus tidak dapat dikembalikan.</p>
    </a-modal>
  </div>
</template>
<script>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { notification } from 'ant-design-vue'
import { PlusOutlined, RestOutlined } from '@ant-design/icons-vue'
import { getUsers, deleteDataUser } from '../../services/axios/modc/users'

const columns = [
  { title: 'No', dataIndex: 'key', key: 'key' },
  { title: 'Nama User', dataIndex: 'username', key: 'name', slots: { customRender: 'name' } },
  { title: 'User Sign', dataIndex: 'userSign', key: 'userSign' },
  { title: 'User Email', dataIndex: 'email', key: 'email' },
  { title: 'User Type', dataIndex: 'role', key: 'role' },
  { title: 'Action', key: 'action', slots: { customRender: 'action' }, align: 'center' },
]

export default {
  components: {
    PlusOutlined,
    RestOutlined,
  },

  setup() {
    const router = useRouter()
    const allUsers = ref([]) // 1. State untuk menyimpan SEMUA data user
    const search = ref('')
    const loading = ref(false)

    const roles = ref([
      { value: 'All Roles', label: 'Pilih Role' },
      { value: 'admin', label: 'Admin' },
      { value: 'receptionist', label: 'Receptionist' },
      { value: 'vendor', label: 'Vendor' },
      { value: 'dcOwner', label: 'DC Owner' },
      { value: 'projectManager', label: 'Project Manager' },
      { value: 'siteManager', label: 'Site Manager' },
      { value: 'eos', label: 'EOS' },
      { value: 'helpdesk', label: 'Help Desk' },
    ])
    const selectedRole = ref('All Roles')

    const isDeleteModalVisible = ref(false)
    const userIdToDelete = ref(null)

    const userData = computed(() => {
      const storedUserData = localStorage.getItem('userData')
      return storedUserData ? JSON.parse(storedUserData).user : {}
    })

    // 2. COMPUTED PROPERTY UNTUK MELAKUKAN FILTER SECARA OTOMATIS
    const filteredData = computed(() => {
      let filtered = allUsers.value

      // Filter berdasarkan search term (nama user)
      if (search.value) {
        filtered = filtered.filter(user =>
          user.username.toLowerCase().includes(search.value.toLowerCase()),
        )
      }

      // Filter berdasarkan role
      if (selectedRole.value !== 'All Roles') {
        filtered = filtered.filter(user => user.role === selectedRole.value)
      }

      // Mapping untuk menambahkan 'key' pada tabel
      return filtered.map((user, index) => ({ ...user, key: index + 1 }))
    })

    const fetchUsers = async () => {
      loading.value = true
      try {
        const { users } = await getUsers() // Fetch semua data, tanpa parameter
        allUsers.value = users
      } catch (error) {
        console.error('Gagal mengambil data user:', error)
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchUsers)

    // watch() tidak lagi diperlukan karena filtering ditangani oleh computed property

    const deleteUser = async userId => {
      try {
        await deleteDataUser(userId)
        notification.success({
          message: 'Berhasil',
          description: 'User telah berhasil dihapus.',
        })
        // 4. HAPUS USER DARI STATE LOKAL, TIDAK PERLU FETCH ULANG
        allUsers.value = allUsers.value.filter(user => user.id !== userId)
      } catch (error) {
        console.error('Gagal menghapus user:', error)
        // ... (error handling)
      }
    }

    const openDeleteModal = userId => {
      userIdToDelete.value = userId
      isDeleteModalVisible.value = true
    }

    const closeDeleteModal = () => {
      isDeleteModalVisible.value = false
      userIdToDelete.value = null
    }

    const handleDelete = () => {
      if (userIdToDelete.value) {
        deleteUser(userIdToDelete.value)
      }
      closeDeleteModal()
    }

    return {
      filteredData, // Kirim data yang sudah difilter ke template
      columns,
      search,
      loading,
      userData,
      isDeleteModalVisible,
      openDeleteModal,
      closeDeleteModal,
      handleDelete,
      roles,
      selectedRole,
    }
  },
}
</script>
